<template>
    <div>
        <div class="alert-danger mt-2" style="text-align: center">
            <h3>
                This software is currently in beta, you are logging in as part
                of the development trial.
            </h3>
        </div>

        <form @submit.prevent="login">
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text">
                        <b-icon-person-fill />
                    </span>
                </div>
                <input
                    type="text"
                    class="form-control"
                    placeholder="Username"
                    autocomplete="username"
                    v-model="username"
                />
            </div>

            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text">
                        <b-icon-lock-fill />
                    </span>
                </div>
                <input
                    type="password"
                    class="form-control"
                    placeholder="Password"
                    autocomplete="current-password"
                    v-model="password"
                />
            </div>

            <div v-if="error" class="input-group mb-3">
                <div class="alert alert-danger">{{ error }}</div>
            </div>

            <div>
                <button type="submit" class="btn btn-primary">
                    Login
                    <b-spinner v-if="loading" small label="loading" />
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import { BIconPersonFill, BIconLockFill } from "bootstrap-vue";

export default {
    name: "Login",
    props: {},

    data() {
        return {
            username: "",
            password: "",
            error: "",
            loading: false,
        };
    },

    methods: {
        async login() {
            this.loading = true;

            try {
                await this.$store.dispatch("auth/logIn", {
                    userId: this.username,
                    password: this.password,
                });

                this.error = "";
                if (this.$route.query.nextPage) {
                    this.$router.push(this.$route.query.nextPage);
                } else {
                    this.$router.push("/main");
                }
            } catch (err) {
                this.error = err.message;
            }

            this.loading = false;
        },
    },

    components: {
        BIconPersonFill,
        BIconLockFill,
    },
};
</script>